const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/**
 * Formats a completion date the way certificates print it: "1 October 2026".
 * Reads the calendar day straight from the "YYYY-MM-DD" prefix, so the day
 * never shifts with the viewer's time zone. Returns "" when there's no
 * readable date, so the caller can show sample text instead.
 */
export function formatCertificateDate(value: string | undefined): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value?.trim() ?? "");
  if (!match) return "";

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
  if (month < 1 || month > 12 || day < 1 || day > daysInMonth) return "";

  return `${day} ${MONTHS[month - 1]} ${year}`;
}

/** "1 October 2026": the local day a timestamp such as a Certificate's sentAt falls on. */
export function formatSentDate(timestamp: string | undefined): string {
  const date = new Date(timestamp ?? "");
  if (Number.isNaN(date.getTime())) return "";
  const pad = (n: number) => String(n).padStart(2, "0");
  return formatCertificateDate(
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
  );
}
